import { render } from "../templates/features-filter.html?vue&type=template&id=1608e421"
import script from "./features-filter.vue?vue&type=script&lang=js"
export * from "./features-filter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__